import React, { useState } from 'react'
import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CRow,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilLockLocked, cilUser } from '@coreui/icons'
import { useNavigate } from 'react-router-dom'
import CFirebase from '../configs/Firebase'
import { createUserWithEmailAndPassword } from 'firebase/auth'
import Spinner from '../components/Spinner'

const Login = () => {
  const [loading, setLoading] = useState(false)
  const [state, setState] = useState({
    email: '',
    password: '',
    confirm: '',
  })
  const navigate = useNavigate()

  /**
   * @param
   * @desc handles login form input change.
   */
  const handleChange = (e) => {
    const { name, value } = e.target

    setState((prevState) => ({ ...prevState, [name]: value }))
  }

  const auth = CFirebase.auth

  /**
   * @param e
   * @desc signs up user via firebase
   */
  const handleSubmit = (e) => {
    e?.preventDefault()

    setLoading(true)
    createUserWithEmailAndPassword(auth, state?.email, state?.password)
      .then(() => {
        setLoading(false)
        window.alert('signup successful.')
        navigate('/login')
      })
      .catch((error) => {
        const errorMessage = error.message
        console.log('Registration Error: ', errorMessage)
        window.alert('signup unsuccessful. ' + errorMessage)
        setLoading(false)
      })
  }

  return (
    <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={6}>
            <CCardGroup>
              <CCard className="p-4 position-relative">
                {loading && (
                  <div
                    className={' d-flex flex-column justify-content-center align-items-center'}
                    style={{
                      position: 'absolute',
                      top: 0,
                      right: 0,
                      left: 0,
                      bottom: 0,
                      backgroundColor: '#ffffffa0',
                      zIndex: 50,
                    }}
                  >
                    <Spinner />
                    <span className={''}>signing up</span>
                  </div>
                )}
                <CCardBody>
                  <CForm onSubmit={handleSubmit}>
                    <h1>Register</h1>
                    <p className="text-medium-emphasis">Create an account</p>
                    <CInputGroup className="mb-3">
                      <CInputGroupText>
                        <CIcon icon={cilUser} />
                      </CInputGroupText>
                      <CFormInput
                        placeholder="Email"
                        type={'email'}
                        name={'email'}
                        required={true}
                        value={state?.email}
                        onChange={handleChange}
                      />
                    </CInputGroup>

                    <CInputGroup className="mb-4">
                      <CInputGroupText>
                        <CIcon icon={cilLockLocked} />
                      </CInputGroupText>
                      <CFormInput
                        type="password"
                        placeholder="Password"
                        required={true}
                        autoComplete="current-password"
                        name={'password'}
                        value={state?.password}
                        onChange={handleChange}
                      />
                    </CInputGroup>

                    <CInputGroup className="mb-4">
                      <CInputGroupText>
                        <CIcon icon={cilLockLocked} />
                      </CInputGroupText>
                      <CFormInput
                        type="password"
                        placeholder="Confirm Password"
                        required={true}
                        name={'confirm'}
                        value={state?.confirm}
                        onChange={handleChange}
                      />
                    </CInputGroup>
                    <CRow>
                      <CCol xs={6}>
                        <CButton type={'submit'} color="primary" className="px-4">
                          Register
                        </CButton>
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

export default Login
